import axios from 'axios';
import {url, PPA_V2_BASE_URL} from '../../../utils/urls';

const withCredentials = true;
const filterRonSites = true;
const splitApps = true;
const headers = { "Content-Type": "application/json" };

export const unmockUserCall = () =>  {
  const headers = { "Content-Type": "application/json" };
  return axios.post(url.ppa.auth.unmock, {}, { headers, withCredentials } )
};

export const updateUserInfo = (data, userUUID) => axios.put(`${url.ppa.users}/${userUUID}`, data, { headers, withCredentials })

// Payment Information
export const getPaymentInformation = (accountUUID) => axios.get(`${url.ppa.accounts}/${accountUUID}/paymentinfo`, { withCredentials });
export const getPayPalInformation = (paymentUUID) => axios.get(`${url.ppa.paymentInfo}/paypal/${paymentUUID}`, { withCredentials });
export const getACHInformation = (paymentUUID) => axios.get(`${url.ppa.paymentInfo}/ach/${paymentUUID}`, { withCredentials });
export const getCheckInformation = (paymentUUID) => axios.get(`${url.ppa.paymentInfo}/check/${paymentUUID}`, { withCredentials });
export const getWireTransferInformation = (paymentUUID) => axios.get(`${url.ppa.paymentInfo}/wire/${paymentUUID}`, { withCredentials });

export const createPaymentInformation = (data, paymentType, accountUUID) => {
  let callURL;
  switch (paymentType) {
      case `PAYPAL`:
          callURL = `${url.ppa.accounts}/${accountUUID}/paymentinfo/paypal`;
          break;
      case `ACH`:
          callURL = `${url.ppa.accounts}/${accountUUID}/paymentinfo/ach`;
          break;
      case `CHECK`:
          callURL = `${url.ppa.accounts}/${accountUUID}/paymentinfo/check`;
          break;
      case `WIRE`:
          callURL = `${url.ppa.accounts}/${accountUUID}/paymentinfo/wire`;
          break;
      default :
          break;
  }
  return axios.post(callURL, data, { withCredentials });
};


export const updatePaymentInformation = (data, paymentType, paymentUUID) => {
  let callURL;
  let config = paymentType === 'PAYPAL' ? { withCredentials } : { headers, withCredentials };
  switch (paymentType) {
      case `PAYPAL`:
          callURL = `${url.ppa.paymentInfo}/paypal/${paymentUUID}`;
          break;
      case `ACH`:
          callURL = `${url.ppa.paymentInfo}/ach/${paymentUUID}`;
          break;
      case `CHECK`:
          callURL = `${url.ppa.paymentInfo}/check/${paymentUUID}`;
          break;
      case `WIRE`:
          callURL = `${url.ppa.paymentInfo}/wire/${paymentUUID}`;
          break;
      default :
          break;
  }
  return axios.put(callURL, data, config);
};

export const getUserPermissions = userUUID => axios.get(`${url.ppa.users}/${userUUID}/permissions`, { withCredentials });

export const addUser = (accountUUID, userData)  => axios.post(`${url.ppa.accounts}/${accountUUID}/users/permissions`, userData, { withCredentials });

export const updateUser = (userUUID, userData) => axios.put(`${url.ppa.users}/${userUUID}/permissions`, userData, { withCredentials });

export const deleteUser = (userUUID, transferredUserUUID = '') => axios.delete(`${url.ppa.users}/${userUUID}?transferredUserUUID=${transferredUserUUID}`, {withCredentials});

export const inviteUser = userUUID => axios.put(`${url.ppa.users}/${userUUID}/invite`, {}, { withCredentials });

export const resendInvite = (userUUID, isResend) => axios.post(`${url.ppa.auth.resend}/user-invite`, {userUUID, isResend} , { withCredentials });

export const getAccountCommentingRoles = accountUUID => axios.get(`${url.ppa.accounts}/${accountUUID}/commentingroles`, {withCredentials});

export const createCustomCommentingRole = requestData => axios.post(`${url.ppa.url}/v1/commentingroles/custom`, requestData , { withCredentials });

export const updateCustomCommentingRole = (roleUUID, requestData) => axios.put(`${url.ppa.url}/v1/commentingroles/${roleUUID}`, requestData , { withCredentials });

export const checkCommentingEmailIfExist = email => axios.get(`${url.ppa.url}/v1/commenting/email/${email}`, {withCredentials});

export const setCommentingAccountStatus = (userUUID, isDeactivated) => axios.put(`${url.ppa.users}/${userUUID}/commentingroles/switch-activation`, {isDeactivated}, { withCredentials });

export const getAccountInfo = accountUUID =>
  axios.get(`${url.ppa.accounts}/${accountUUID}`, {withCredentials});

export const updateInvoiceConfig = (accountUUID, accountInfo) =>
  axios.put(`${url.ppa.url}/v1/accounts/invoiceConfig/${accountUUID}`, accountInfo, {withCredentials});

export const getAccountSites = (accountUUID) =>
    axios.get(`${url.ppa.accounts}/${accountUUID}/sites`, {
        withCredentials, params: {
            filterRonSites, splitApps
        }
    });

export const getAccountSitesAndApps = accountUUID =>
    axios.get(`${url.ppa.accounts}/${accountUUID}/sites`, {
        withCredentials, params: {
            filterRonSites, splitApps
        }
    });

export const getAccountRevenueShare = (date, accountUUID) =>
  axios.get(`${url.ppa.url}/internal/v2/revenueshares/${date}/account/${accountUUID}`, {withCredentials});

export const updateAccountRevenueShare = (accountUUID, revenueShare) =>
  axios.put(`${url.ppa.url}/internal/v2/revenueshares/account/${accountUUID}`, revenueShare);

export const getSiteRevenueShare = (date, accountUUID) =>
  axios.get(`${url.ppa.url}/internal/v2/revenueshares/${date}/${accountUUID}/sites`);

export const updateSiteRevenueShare = (accountUUID, revenueShare) =>
  axios.put(`${url.ppa.url}/internal/v2/revenueshares/account/${accountUUID}/sites`, revenueShare);

export const fetchInvoices = (accountUUID, year) =>
  axios.get(`${url.ppa.url}/internal/v1/accounts/invoices/${accountUUID}/${year}`, {withCredentials});

export const getSiteEmojiConfiguration = siteUUID =>
  axios.get(`${url.ppa.emojis}/sites/${siteUUID}/configurations`, {withCredentials});

export const getEmojiCategories = () =>
  axios.get(`${url.ppa.emojis}/categories`, {withCredentials});

export const setSiteEmojiCategories = ({siteUUID, emojis}) =>
  axios.put(`${url.ppa.emojis}/sites/${siteUUID}/configurations`, {withCredentials, emojis});

export const sendProductTypeAccessRequest = ({accountUUID, productType}) =>
  axios.post(`${url.ppa.accounts}/${accountUUID}/product-access-requests`, { productType },  { withCredentials });

export const getProductTypeAccess = ({accountUUID, productType}) =>
  axios.get(`${url.ppa.accounts}/${accountUUID}/product-access-requests?productType=${productType}`, { withCredentials });

export const getAccountProducts = (accountUUID) =>
  axios.get(`${url.ppa.accounts}/${accountUUID}/product-access-requests/status?status=APPROVED`, { withCredentials });

export const getAccountProductsStatus = ({ accountUUID, status }) =>
  axios.get(`${url.ppa.accounts}/${accountUUID}/product-access-requests/status?status=${status}`, { withCredentials });

export const userSignOutCall = () => 
  axios.get(`${url.ppa.auth.logout}`, { withCredentials });

export const getAccountSettings = accountUUID => axios.get(`${PPA_V2_BASE_URL}/accountsettings/${accountUUID}`, {withCredentials});

export const updateAccountSettings = ({accountUUID, settings}) =>
    axios.put(`${PPA_V2_BASE_URL}/accountsettings/${accountUUID}`, {...settings}, {withCredentials});

export const getAccountUsers = accountUUID => axios.get(`${url.ppa.accounts}/${accountUUID}/users/permissions`, { withCredentials });

export const getAllReportsByAccount = accountUUID => axios.get(`${PPA_V2_BASE_URL}/report/accounts/${accountUUID}`, { withCredentials });

export const sendReport = report => axios.post(`${PPA_V2_BASE_URL}/report`, report, { withCredentials });

export const getReport = reportUUID => axios.post(`${PPA_V2_BASE_URL}/report/${reportUUID}`, { withCredentials });

export const setReport = report => axios.put(`${PPA_V2_BASE_URL}/report/${report.reportUUID}`, report, { withCredentials });

export const removeReport = reportUUID => axios.delete(`${PPA_V2_BASE_URL}/report/${reportUUID}`, { withCredentials });

export const downloadReport = reportUUID => axios.get(`${PPA_V2_BASE_URL}/report/${reportUUID}/download`, { withCredentials });

export const getPreviewReport = report => axios.post(`${PPA_V2_BASE_URL}/report/preview`, report, { withCredentials });

export const getPreviewFile = report => axios.post(`${PPA_V2_BASE_URL}/report/preview`, report, { withCredentials, responseType: 'blob' });

export const fetchInvoice = (accountUUID, date) => axios.get(`${url.ppa.url}/internal/v1/accounts/invoice/${accountUUID}/${date}`, {withCredentials, responseType: "blob"});

export const updateProductRevenueDeduction = requestData => axios.put(`${url.ppa.url}/internal/v2/productrevenuededuction`, requestData, { withCredentials })

export const updateProductRevenueDeductionForAccount = (accountUUID,requestData) => axios.put(`${url.ppa.url}/internal/v2/account/${accountUUID}/productrevenuededuction`, requestData, { withCredentials })

export const updateAccountInfo = (accountUUID, requestData) => axios.put(`${url.ppa.url}/internal/v1/accounts/${accountUUID}/info`, requestData, { withCredentials })

export const getDashboardMessage = () => axios.get(`${url.ppa.url}/v1/account/dashboardmessage`, { withCredentials })

export const updateDashboardMessage = requestData => axios.put(`${url.ppa.url}/v1/account/dashboardmessage`, requestData, { withCredentials })

export const getHistoricalData = accountUUID => axios.get(`${url.ppa.url}/v1/accounts/${accountUUID}/historical`, { withCredentials, responseType: 'blob' })

export const updateDisplayInvoice = requestData=>axios.post(`${url.ppa.url}/internal/v1/accounts/invoice/updateDisplayInvoice`, requestData, {withCredentials})

export const getReportApiKey = accountUUID => axios.get(`${url.ppa.url}/v1/report/apiKey/${accountUUID}`, {withCredentials})

export const createReportApiKey = accountUUID => axios.post(`${url.ppa.url}/v1/report/apiKey/${accountUUID}`, {withCredentials})

export const updateApiAccess = ({accountUUID, settings}) =>
    axios.put(`${PPA_V2_BASE_URL}/accountsettings/${accountUUID}/enableApiAccess`, {...settings}, {withCredentials});

export const uploadPolicyViolationCSV = ({requestData}) => axios.post(`${url.ppa.url}/internal/v1/uploadPolicyViolationListCSVToS3`, requestData , { headers, withCredentials });
export const getPolicyViolationCSV = () => axios.get(`${url.ppa.url}/internal/v1/getPolicyViolationListCSVFromS3`, {} , { headers, withCredentials });

export const setThemeForAllProducts = ({ siteId, data }) => axios.put(`${url.ppa.url}/v1/sites/${siteId}/site-themes/configs`, data, { headers, withCredentials });